export default "__VITE_ASSET__CClrm_C5__"